import React, { useEffect } from 'react';
import { graphql, navigate } from 'gatsby';
import Layout from '../components/Layout/Layout';
import SeoDatoCMS from '../components/Layout/SeoDatocms';
import Blocks from '../components/Blocks/Blocks';
import HomeHero from '../components/Global/HomeHero/HomeHero';
import useRegionSelector from '../hooks/useRegionSelector';

const Landing = ({ data: { landing, favicon } }) => {
  const { region } = useRegionSelector();
  const { title, introduction, image, imageMobile, alternativeHero, ctas, blocks = [], seo } = landing;

  useEffect(() => {
    if (!region) return;

    if (region == 'UK') {
      navigate('/');
      return;
    }

    navigate(`/${region.toLowerCase()}`);
  }, [region]);

  return (
    <Layout>
      <SeoDatoCMS seo={seo} favicon={favicon} />
      <HomeHero
        title={title}
        subtitle={introduction}
        image={image}
        mobileImage={imageMobile}
        alternativeHero={alternativeHero}
        ctas={ctas}
      />
      <Blocks blocks={blocks} />
    </Layout>
  );
};

export default Landing;

export const LandingQuery = graphql`
  query LandingById($id: String) {
    favicon: datoCmsSite {
      faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }
    landing: datoCmsLanding(id: { eq: $id }) {
      title
      introduction
      image {
        url
        alt
        gatsbyImageData
      }
      imageMobile {
        url
        alt
        gatsbyImageData
      }
      alternativeHero
      ctas {
        ...BlockCta
      }
      region {
        ... on DatoCmsRegion {
          id
          label
        }
      }
      blocks {
        __typename
        ... on DatoCmsUpdatesBlock {
          ...BlockUpdates
        }
        ... on DatoCmsVideosBlock {
          ...BlockResourcesVideos
        }
        ... on DatoCmsPublicationsBlock {
          ...BlockResourcesPublications
        }
        ... on DatoCmsAreasOfWorkBlock {
          ...BlockAreasWork
        }
        ... on DatoCmsTakeActionBlock {
          ...BlockTakeAction
        }
        ... on DatoCmsFormBlock {
          ...BlockForm
        }
        ... on DatoCmsSocialNetworksBlock {
          ...BlockSocialNetworks
        }
      }
      seo: seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }
  }
`;
